import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  LINK_VARIANT_EXTRALIGHT,
  Link,
  TEXT_VARIANT_LIGHT,
  Text,
} from 'mailup-web-components'

import { notifyParent } from 'mailup-react-helpers'

interface MessageDetailsProps {
  id?: number
  subject?: string
  channel: 'email' | 'sms'
}

const MessageDetails: FC<MessageDetailsProps> = ({ id, subject, channel }) => {
  const intl = useIntl()

  const handleClickDetails = (): void => {
    if (channel === 'email') {
      notifyParent('openPreviewMainFrame', [id])
    } else {
      notifyParent('openSMSPreview', [id])
    }
  }

  if (id !== undefined && id > 0) {
    if (subject !== undefined && subject.length > 0) {
      return (
        <Link variant={LINK_VARIANT_EXTRALIGHT} onClick={handleClickDetails}>
          {intl.formatMessage({ id: 'Load.MailupCommon.Id' })} {id}
          {' - '}
          {subject}
        </Link>
      )
    } else {
      return (
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({ id: 'Load.MailupCommon.Id' })} {id}
          {' - '}
          {intl.formatMessage({ id: 'Load.Common.MessageNotAvailable' })}
        </Text>
      )
    }
  }

  if (subject !== undefined && subject.length > 0) {
    return <Text variant={TEXT_VARIANT_LIGHT}>{subject}</Text>
  }

  return null
}

export default MessageDetails
